export class Cambio {
    idUsuario: number;
    campoCambio: string;
    fechaCambio: Date;
    valorAnterior: string;
    valorPosterior: string;

    constructor() { }

    static toModel(json: string) {
        const data = JSON.parse(json);
        const toReturn = new Cambio();

        toReturn.idUsuario = data.ID_USUARIO;
        toReturn.campoCambio = data.CAMPO_CAMBIO;
        if (data.FECHA_CAMBIO) {
            toReturn.fechaCambio = new Date(data.FECHA_CAMBIO);
        }
        toReturn.valorAnterior = data.VALOR_ANTERIOR;
        toReturn.valorPosterior = data.VALOR_POSTERIOR;

        return toReturn;
    }
}

export class Estado {
    activo: Date;
    bloqueado: Date;
    expurgoLogico: Date;
    expurgoFisico: Date;
    baja: Date;
    prestado: Date;
    transporte: Date;
    pendienteRecepcion: Date;

    constructor() { }

    static toModel(json: string) {
        const data = JSON.parse(json);
        const toReturn = new Estado();

        toReturn.activo = data.ACTIVO ? new Date(data.ACTIVO) : undefined;
        toReturn.bloqueado = data.BLOQUEADO ? new Date(data.BLOQUEADO) : undefined;
        toReturn.expurgoLogico = data.EXPURGO_LOGICO ? new Date(data.EXPURGO_LOGICO) : undefined;
        toReturn.expurgoFisico = data.EXPURGO_FISICO ? new Date(data.EXPURGO_FISICO) : undefined;
        toReturn.baja = data.BAJA ? new Date(data.BAJA) : undefined;
        toReturn.prestado = data.PRESTADO ? new Date(data.PRESTADO) : undefined;
        toReturn.transporte = data.TRANSPORTE ? new Date(data.TRANSPORTE) : undefined;
        toReturn.pendienteRecepcion = data.PENDIENTE_RECEPCION ? new Date(data.PENDIENTE_RECEPCION) : undefined;

        return toReturn;
    }
}

export class Bloqueo {
    idUsuarioBloqueo: number;
    infoBloqueo: string;
    fechaInicioBloqueo: Date;
    fechaFinBloqueo: Date;
    idUsuarioDesbloqueo: number;

    constructor() { }

    static toModel(json: string) {
        const data = JSON.parse(json);
        const toReturn = new Bloqueo();

        toReturn.idUsuarioBloqueo = data.ID_USUARIO_BLOQUEO;
        toReturn.infoBloqueo = data.INFO_BLOQUEO;
        toReturn.fechaInicioBloqueo = data.FECHA_INICIO_BLOQUEO ? new Date(data.FECHA_INICIO_BLOQUEO) : undefined;
        toReturn.fechaFinBloqueo = data.FECHA_FIN_BLOQUEO ? new Date(data.FECHA_FIN_BLOQUEO) : undefined;
        toReturn.idUsuarioDesbloqueo = data.ID_USUARIO_DESBLOQUEO;

        return toReturn;
    }
}
